import {
  SEARCH_CODE_PORTAL,
  SEARCH_CODE_PORTAL_SUCCESS,
  SEARCH_CODE_PORTAL_FAIL,
  GET_SEARCH_RESULT,
  GET_SEARCH_RESULT_SUCCESS,
  GET_SEARCH_RESULT_FAIL,
  GET_CAPCHA,
  GET_CAPCHA_SUCCESS,
  GET_CAPCHA_FAIL,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_FAIL,
  RESET_TYPE_DOWNLOAD,
} from "./actionTypes";

export const resetDownloadType = () => ({
  type: RESET_TYPE_DOWNLOAD,
});
export const getCapcha = (actionType, data) => ({
  type: GET_CAPCHA,
  payload: { actionType, data },
});

export const getCapchaSuccess = params => ({
  type: GET_CAPCHA_SUCCESS,
  payload: params,
});

export const getCapchaFail = params => ({
  type: GET_CAPCHA_FAIL,
  payload: params,
});
export const searchCodePortal = params => ({
  type: SEARCH_CODE_PORTAL,
  payload: params,
});

export const searchCodePortalSuccess = params => ({
  type: SEARCH_CODE_PORTAL_SUCCESS,
  payload: params,
});

export const searchCodePortalFail = params => ({
  type: SEARCH_CODE_PORTAL_FAIL,
  payload: params,
});
export const getSearchResult = params => ({
  type: GET_SEARCH_RESULT,
  payload: params,
});

export const getSearchResultSuccess = params => ({
  type: GET_SEARCH_RESULT_SUCCESS,
  payload: params,
});

export const getSearchResultFail = params => ({
  type: GET_SEARCH_RESULT_FAIL,
  payload: params,
});
export const downloadFile = params => ({
  type: DOWNLOAD_FILE,
  payload: params,
});

export const downloadFileSuccess = params => ({
  type: DOWNLOAD_FILE_SUCCESS,
  payload: params,
});

export const downloadFileFail = params => ({
  type: DOWNLOAD_FILE_FAIL,
  payload: params,
});
